export default __webpack_public_path__ + "static/media/family.9c7692e6.png";